import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar.jsx';
import UrgencyBar from './UrgencyBar.jsx';
import FloatingTutor from './FloatingTutor.jsx';
import FeedbackWidget from './FeedbackWidget.jsx';
import Onboarding from './Onboarding.jsx';
import Search from './Search.jsx';
import VerifyEmailBanner from './VerifyEmailBanner.jsx';
import GuestSignupBanner from './GuestSignupBanner.jsx';
import { Menu, Logo } from './Icons.jsx';

const ONBOARDED_KEY = 'mm-onboarded-v1';

export default function Layout() {
  const [open, setOpen] = useState(false);
  const [onboardOpen, setOnboardOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  useEffect(() => {
    try {
      if (!localStorage.getItem(ONBOARDED_KEY)) {
        const t = setTimeout(() => setOnboardOpen(true), 600);
        return () => clearTimeout(t);
      }
    } catch {}
  }, []);
  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setSearchOpen((s) => !s);
      }
    };
    window.addEventListener('keydown', onKey);
    window.__mmOpenSearch = () => setSearchOpen(true);
    return () => { window.removeEventListener('keydown', onKey); delete window.__mmOpenSearch; };
  }, []);
  const closeOnboard = () => {
    try { localStorage.setItem(ONBOARDED_KEY, '1'); } catch {}
    setOnboardOpen(false);
  };
  return (
    <>
      <UrgencyBar />
      <VerifyEmailBanner />
      <GuestSignupBanner />
      <div className="app">
        <div className="mobile-bar">
          <button className="menu-btn" aria-label="Open menu" onClick={() => setOpen(true)}>
            <Menu />
          </button>
          <Logo width={28} height={28} onLight />
          <div className="brand-name" style={{ marginLeft: 8 }}>
            <span className="brand-main" style={{ fontSize: 18 }}>Medi</span>
            <span className="brand-sub">powered by Medic Mind</span>
          </div>
        </div>
        <Sidebar open={open} onClose={() => setOpen(false)} />
        <main className="main">
          <Outlet />
        </main>
      </div>
      <FloatingTutor />
      <FeedbackWidget />
      <Onboarding open={onboardOpen} onClose={closeOnboard} />
      <Search open={searchOpen} onClose={() => setSearchOpen(false)} />
      <style>{`
        @keyframes mm-pulse-dot { 0%, 100% { opacity: 1; transform: scale(1); } 50% { opacity: 0.3; transform: scale(0.7); } }
        @keyframes mm-slide-up { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </>
  );
}
